import { CSSProperties } from "react";

export const ACCIDENT_BOOK_MODAL_STYLE: CSSProperties = {
  width: "min(75vw, 56rem)",
};
